'use client';

import Link from '@lichtblick/link';
import type { MouseEventHandler, ReactNode } from 'react';

const openConsentModal: MouseEventHandler<HTMLAnchorElement> = (event) => {
  event.preventDefault();
  event.stopPropagation();
  window.__ucCmp?.showSecondLayer();
};

export const FooterConsentLink = ({
  children,
  className,
  href,
}: {
  children: ReactNode;
  className?: string;
  href: string;
}) => (
  <Link className={className} href={href} onClick={openConsentModal}>
    {children}
  </Link>
);
